import JSEncrypt from '@/utils/jsencrypt.js';

/**
 * RSA 公钥加密（与登录密码、checkout 等场景共用）
 */
export function encryptByPublicKey(content) {
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(
    'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAMEfmsO1l44W6/RS9Hkx74Ey36aHExrCvjFYhRVP7/Q+8SG+vWFxMvGShQTA8EfQS2ECgDhVc+LFB14qhFl/JEcCAwEAAQ=='
  );
  return encrypt.encrypt(content);
}
